<template>
    <div v-if="!loadingPage" class="pb-2">
        <h3 class="mb-2 text-primary mt-50">گزارش سفارشات</h3>
        <b-row>
            <b-col md="4" class="mt-25">
                <b-form-group label="تاریخ" label-for="dateId">
                    <b-form-input id="dateId" class="text-center main-input font-weight-bolder pointer"
                        :value="parameters.date ? formatDate(parameters.date) : null" autocomplete="off"
                        name="dateId" />
                    <date-picker v-model="parameters.date" :max="currentDate" format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jDD" custom-input="#dateId" />
                </b-form-group>
            </b-col>
            <b-col md="4" class="mt-25">
                <b-form-group label="شماره فاکتور" label-for="storeOrderNumberId">
                    <b-form-input v-model="parameters.storeOrderNumber" @keyup.enter="getOrdersHistory"
                        id="storeOrderNumberId" dir="ltr" type="number" autocomplete="off" class="text-center"
                        name="storeOrderNumberId" />
                </b-form-group>
            </b-col>
            <b-col md="4" class="mt-25">
                <b-form-group label="وضعیت مرجوعی" label-for="isReturnedId">
                    <v-select v-model="parameters.isReturned" dir="rtl" :options="isReturnedData" autocomplete="off"
                        :searchable="false" id="isReturnedId" :reduce="(value) => value.id" class="bg-white"
                        style="border-radius: 6px;" label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="4" class="mt-25">
                <b-form-group label="نوع سفارش" label-for="typeId">
                    <v-select v-model="parameters.type" dir="rtl" :options="typeData" id="typeId" autocomplete="off"
                        :searchable="false" :reduce="(value) => value.id" class="bg-white" style="border-radius: 6px;"
                        label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="4" class="mt-25">
                <b-form-group label="نوع پرداخت" label-for="paymentMethodId">
                    <v-select v-model="parameters.paymentMethod" dir="rtl" :options="paymentMethodData"
                        autocomplete="off" id="paymentMethodId" :reduce="(value) => value.id" class="bg-white"
                        :searchable="false" style="border-radius: 6px;" label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="4" class="mt-md-2 mt-50">
                <b-button variant="info" @click="getOrdersHistory" :disabled="loading"
                    class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                    <span>اعمال فیلتر</span>
                    <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                </b-button>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col v-for="transaction in transactionData" :key="transaction.mode" md="6" lg="4">
                <b-card class="card-transaction" no-body>
                    <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                        <b-card-body>
                            <div class="transaction-item">
                                <div>
                                    <div>
                                        <h5 class="mb-50" :class="transaction.color">
                                            {{ transaction.mode }}
                                        </h5>
                                    </div>
                                    <div class="d-flex align-items-center" :class="transaction.color">
                                        <h4 class="mb-0" :class="transaction.color">
                                            {{ transaction.payment.toLocaleString('fa-IR') }}
                                        </h4>
                                        <h6 class="mb-0 ml-25" :class="transaction.color">
                                            {{ transaction.types }}
                                        </h6>
                                    </div>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="42" :variant="transaction.avatarVariant">
                                            <feather-icon size="20" :icon="transaction.avatar" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-card-body>
                    </b-overlay>
                </b-card>
            </b-col>
            <b-col v-for="item in sellsPerMethod" :key="`method_${item.method}`" md="6" lg="4">
                <b-card class="card-transaction" no-body>
                    <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                        <b-card-body>
                            <div class="transaction-item">
                                <div>
                                    <div>
                                        <h5 class="mb-50">
                                            {{ paymentMethod_Status(item.method) }}
                                        </h5>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <h4 class="mb-0">
                                            {{ item.amount.toLocaleString('fa-IR') }}
                                        </h4>
                                        <h6 class="mb-0 ml-25">
                                            ریال
                                        </h6>
                                    </div>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="42" variant="light-secondary">
                                            <feather-icon size="20" icon="GridIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-card-body>
                    </b-overlay>
                </b-card>
            </b-col>
        </b-row>
        <b-card class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table v-if="history.length" responsive :items="history" :fields="fields" class="mb-0" striped>
                    <template #cell(isReturned)="data">
                        <div :class="{ 'text-warning': data.item.isReturned }">
                            {{ data.item.isReturned ? 'مرجوع شده' : '-' }}
                        </div>
                    </template>
                    <template #cell(payableAmount)="data">
                        <div>
                            {{ data.item.payableAmount.toLocaleString('fa-IR') }}
                        </div>
                    </template>
                    <template #cell(cashbackAmount)="data">
                        {{ data.item.cashbackAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(usedWalletAmount)="data">
                        {{ data.item.usedWalletAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(createdAt)="data">
                        <span>
                            {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                2).join(":") }}
                        </span>
                    </template>
                    <template #cell(paymentMethod)="data">
                        {{ paymentMethod_Status(data.item.paymentMethod) }}
                    </template>
                    <template #cell(type)="data">
                        {{ type_Status(data.item.type) }}
                    </template>
                    <template #cell(orderReturn)="data">
                        <feather-icon @click="showModalReturn(data.item.id, data.item.isReturned, data.item.createdAt)"
                            size="19" icon="RotateCcwIcon" class="pointer" color="#8d88a3" />
                    </template>
                    <template #cell(ordersList)="data">
                        <b-spinner v-if="loadingButton[data.index]" variant="info" small></b-spinner>
                        <feather-icon v-else @click="showOrderList(data.item.id, data.index)" icon="ShoppingBagIcon"
                            class="text-info pointer" size="20" />
                    </template>
                </b-table>
                <div v-else class="text-center pt-5 pb-4">
                    موردی وجود ندارد
                </div>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="getOrdersHistory" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />


        <!------------------------------- modal order return ------------------------------->
        <b-modal id="order-return" title="ثبت مرجوعی" centered :hide-footer="true" title-class="font-weight-bolder"
            size="md">
            <div class="p-1">
                <h5 class="text-center text-danger mb-2">
                    بعد از ثبت مرجوعی، فاکتور همراه با تمامی اقلام مرجوع خواهد شد.
                </h5>
                <div class="d-flex align-items-center pt-1">
                    <b-button @click="$bvModal.hide('order-return')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button @click="orderReturn" class="d-flex align-items-center justify-content-center w-50"
                        variant="danger" :disabled="loadingButton2">
                        <span>ثبت</span>
                        <b-spinner v-if="loadingButton2" class="ml-50" variant="white" small></b-spinner>
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!------------------------------- modal show order list ------------------------------->
        <b-modal id="show-order-list" title="جزئیات سفارش" centered :hide-footer="true" title-class="font-weight-bolder"
            size="lg">
            <div>

                <invoiceDetail :orderDetails="orderDetails" />

                <b-button v-if="this.certificateId || this.certificateId == 0"
                    @click="$refs.Printer.printCustomerInvoice()" class="w-100 mb-1" variant="primary">
                    پرینت فاکتور
                </b-button>
            </div>
        </b-modal>

        <div v-if="certificateId || certificateId == 0">
            <Printer ref="Printer" :customerInvoice="orderPrint" :provider="provider"
                @deleteInvoice="$bvModal.hide('show-order-list')" />
        </div>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';
import Printer from '@/@core/components/printer/index.vue';
import invoiceDetail from '@/@core/components/invoice-detail/index.vue';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Printer,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        vSelect,
        invoiceDetail
    },
    mixins: [accessHandling],
    data() {
        return {
            certificateId: null,
            loadingButton: [],
            storeId: null,
            orderPrint: {},
            orderDetails: {},
            urlName: '',
            provider: {},
            loadingPage: true,
            loading: false,
            loadingButton2: false,
            history: [],
            paymentMethodData: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'نقدی' },
                { id: 1, name: 'کارت' },
                { id: 3, name: 'واریز به حساب' },

            ],
            typeData: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'داخل سالن' },
                { id: 1, name: 'بیرون بر' },
            ],
            isReturnedData: [
                { id: null, name: 'نمایش همه' },
                { id: true, name: 'مرجوع شده' },
                { id: false, name: 'مرجوع نشده' },
            ],
            transactionData: [
                {
                    mode: 'فروش',
                    types: 'ریال',
                    avatar: 'ArrowUpCircleIcon',
                    avatarVariant: 'light-primary',
                    payment: null,
                    color: 'text-primary',
                },
                {
                    mode: 'مرجوعی',
                    types: 'ریال',
                    avatar: 'ArrowDownCircleIcon',
                    avatarVariant: 'light-danger',
                    payment: null,
                    color: 'text-danger',
                },
                {
                    mode: 'خالص',
                    types: 'ریال',
                    avatar: 'DollarSignIcon',
                    avatarVariant: 'light-success',
                    payment: null,
                    color: 'text-success',
                },
            ],
            fields: [
                {
                    key: 'storeOrderNumber',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'createdAt',
                    label: 'زمان ثبت',
                },
                {
                    key: 'usedWalletAmount',
                    label: 'اعتبار استفاده شده (ریال)',
                },
                {
                    key: 'payableAmount',
                    label: 'مبلغ پرداخت شده (ریال)',
                },
                {
                    key: 'cashbackAmount',
                    label: 'اعتبار صادر شده (ریال)',
                },
                {
                    key: 'type',
                    label: 'نوع سفارش',
                },
                {
                    key: 'paymentMethod',
                    label: 'نوع پرداخت',
                },
                {
                    key: 'isReturned',
                    label: 'وضعیت مرجوعی',
                },
                {
                    key: 'ordersList',
                    label: 'جزئیات',
                },
                {
                    key: 'orderReturn',
                    label: 'ثبت مرجوعی',
                },
            ],
            currentDate: '',
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                isReturned: null,
                storeOrderNumber: null,
                type: null,
                paymentMethod: null,
                date: null,
            },
            orderId: null,
            sellsPerMethod: [],
        }
    },
    computed: {
        type_Status() {
            return (status) => {
                if (status == 0) {
                    return 'داخل سالن'
                }
                if (status == 1) {
                    return 'بیرون بر'
                }
            }
        },
        paymentMethod_Status() {
            return (status) => {
                if (status == 0) {
                    return 'نقدی'
                }
                if (status == 1) {
                    return 'کارت'
                }
                if (status == 3) {
                    return 'واریز به حساب'
                }
                if (status == 255) {
                    return 'ترکیبی'
                }
            }
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        showOrderList(id, index) {
            if (this.accessHandling('employee', 'order_details_view')) {
                this.orderPrint = {}
                this.$set(this.loadingButton, index, true);
                storeService.orderDetails(this.storeId, id).then(({ data }) => {
                    let dataOrder = data
                    this.orderPrint.storeOrderNumber = data.storeOrderNumber
                    this.orderPrint.dailyOrderNumber = data.dailyOrderNumber
                    this.orderPrint.createdAt = data.createdAt
                    this.orderPrint.urlName = this.urlName
                    this.orderPrint.taxAmount = data.taxAmount
                    this.orderPrint.discountAmount = data.discountAmount
                    this.orderPrint.usedWalletAmount = data.usedWalletAmount
                    this.orderPrint.orderAmount = data.totalAmount
                    this.orderPrint.amountPayable = data.payableAmount
                    data.campaign ? this.orderPrint.campaignDiscountAmount = data.campaign.discountAmount : null
                    this.orderPrint.productDiscountAmount = data.productDiscountAmount
                    if (data.customer) {
                        this.orderPrint.firstName = data.customer.firstName
                        this.orderPrint.lastName = data.customer.lastName
                        this.orderPrint.phoneNumber = data.customer.phoneNumber
                    }
                    this.orderPrint.type = data.type
                    if (data.type == 1) {
                        this.orderPrint.address = data.address
                    }
                    this.orderPrint.items = []
                    if (dataOrder.items.length) {
                        dataOrder.items.forEach((obj, index) => {
                            this.orderPrint.items[index] = {};
                            this.orderPrint.items[index].name_Fa = obj.productName
                            this.orderPrint.items[index].number = obj.count
                            this.orderPrint.items[index].finalPrice = obj.finalPrice
                        });
                    }
                    this.orderDetails = data
                    this.$set(this.loadingButton, index, false);
                    this.$bvModal.show('show-order-list')
                })

                    .catch((err) => {
                        this.$set(this.loadingButton, index, false);
                    });
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        getStoreDetails() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                data.name_Fa ? this.provider.name = data.name_Fa : this.provider.name = data.name_En;
                this.urlName = data.name_En
                this.provider.logo = data.logoImage;
                this.getOrdersHistory()
            })
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        getOrdersHistory() {
            this.loading = true
            this.loadingButton = []
            storeService.ordersHistory(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.history = data.items
                    this.sellsPerMethod = data.sellsPerMethod
                    this.transactionData[0].payment = data.totalSell + data.totalReturned
                    this.transactionData[1].payment = data.totalReturned
                    this.transactionData[2].payment = data.totalSell
                    if (this.history.length) {
                        this.history.forEach(obj => {
                            this.loadingButton.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.history = data.items
                        this.sellsPerMethod = data.sellsPerMethod
                        this.transactionData[0].payment = data.totalSell + data.totalReturned
                        this.transactionData[1].payment = data.totalReturned
                        this.transactionData[2].payment = data.totalSell
                        if (this.history.length) {
                            this.history.forEach(obj => {
                                this.loadingButton.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        showModalReturn(id, isReturned, createdAt) {
            if (this.accessHandling('employee', 'order_return')) {
                const today = new Date();
                let currentDate;
                let createdDate;
                currentDate = this.formatDate2(today);
                createdDate = createdAt.substring(0, 10);
                if (currentDate == createdDate) {
                    if (isReturned) {
                        this.$notif({ type: 'normal', title: 'این فاکتور مرجوع شده است' });
                    }
                    else {
                        this.orderId = id
                        this.$bvModal.show('order-return')
                    }
                }
                else {
                    this.$notif({ type: 'normal', title: 'مرجوعی فقط در روز صدور فاکتور امکان‌پذیر است' });
                }
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        orderReturn() {
            this.loadingButton2 = true;
            storeService.orderReturn(this.storeId, this.orderId).then(({ data }) => {
                this.$notif({ type: 'success', title: 'فاکتور با موفقیت مرجوع شد' });
                this.getOrdersHistory()
            })
                .finally(() => {
                    this.$bvModal.hide('order-return')
                    this.loadingButton2 = false;
                });
        },
    },
    mounted() {
        this.certificateId = localStorage.getItem("certificateId");
        this.storeId = localStorage.getItem("storeId")
        const today = new Date();
        this.currentDate = this.formatDate2(today);
        this.parameters.date = this.currentDate
        this.getStoreDetails()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>